module.exports = __webpack_public_path__ + "static/media/D89.5200b20f.svg";